export enum RowSpace {
  None = 'none',
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Middle = 'middle',
  Large = 'large',
}
